import type { NetworkCasseDetail, NetworkLossDetailSelectionParams } from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'
import { buildNetworkLossDetailParams } from './network-loss-detail-params'

export const fetchNetworkCasseDetail = async (
  selection: NetworkLossDetailSelectionParams,
): Promise<NetworkCasseDetail> => {
  const response = await gozokiApiWithAuth.get<NetworkCasseDetail>(
    '/stores/get-network-casse-detail',
    { params: buildNetworkLossDetailParams(selection) },
  )
  return response.data
}
